import React from 'react';
import './representation.layout.sass';
import {connect} from 'react-redux';
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import representationImage from '../../assets/image/agency.png';
import {Form, Row, Col, FormControl, ControlLabel, Schema, Button, Alert, FormGroup, Icon} from "rsuite";
import pinOrange from '../../assets/image/icons/pinOrange.png';
import {createStructuredSelector} from "reselect";
import {selectCities, selectLatlng} from "../../redux/site/site.selector";
import {SetCities, SetLatLng} from "../../redux/site/site.actions";
import ModalTypes from "../../redux/modals/modals.types";
import {selectRepresentationModal} from "../../redux/modals/modals.selector";
import 'leaflet/dist/leaflet.css';
import MapModalComponent from "../../components/mapModal/mapModal.component";
import Axios from 'axios'
import {Setting} from "../../setting";


class RepresentationLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            state : '',
            formValue: {
                email: '',
                full_name: '',
                phone: '',
                lat: '',
                lng: '',
                msg: '',
                address: '',
                city: ''
            },
        }
    }

    componentDidMount() {
        const {setCities} = this.props;
        Axios.get(`${Setting.apiUrl}api/state/list`)
            .then(res=> {
                if(res.status === 200){
                    this.setState({state : res.data.data});
                }else {
                    Alert.error('مشکلی در برقراری ارتباط به وجود آمده است، لطفا مجدا تلاش فرمایید.')
                }
            })
            .then(()=>{
                Axios.get(`${Setting.apiUrl}api/city/list?state=${1}`)
                    .then(res => {
                        setCities(res.data.data);
                    });
            })
    }

    handleSubmit = (value) => {
        const {getLatLng, getCities} = this.props;
        const {region, email, full_name, msg, phone} = this.state.formValue;
        if(value){
            let lastData = {
                email: email,
                full_name: full_name,
                phone: phone,
                lat: getLatLng[0],
                lng: getLatLng[1],
                msg: msg,
                city: getCities.find(item => item.name === region).id,
                address: '-'
            };

            Axios.post(`${Setting.apiUrl}api/representative/add`, lastData)
                .then(res => {
                    document.getElementById('form-repre').reset();
                    Alert.success('فرم شما با موفقیت ثبت شد منتظر تماس ما باشید.');
                });
        }else {
            Alert.error('لطفا اطلاعات خود را صحیح و کامل وارد کنید')
        }
    };

    render() {
        const{getCities, mapModal, setCities, ToggleMapModal, getLatLng} = this.props;
        const {ostan} = require('iran-cities-json');
        const {StringType, NumberType} = Schema.Types;
        const model = Schema.Model({
            full_name: StringType().isRequired('نام خود را وارد کنید'),
            phone: NumberType()
                .isRequired('لطفا شماره تلفن خود را وارد کنید'),
            email: StringType()
                .isEmail('لطفا یک ایمیل معتبر انتخاب کنید')
        });

        const getShahr = (Ostan) => {
            let ostanId = ostan.find(item => item.name === Ostan).id;
            Axios.get(`${Setting.apiUrl}api/city/list?state=${ostanId}`)
                .then(res => {
                    setCities(res.data.data);
                });
        };

        return (
            <div>
                <SubHeaderComponent imageSrc={representationImage} pageName='درخواست نمایندگی'/>
                <div className='representation-div'>
                    <Form
                        formValue={this.state.formValue}
                        id='form-repre'
                        model={model}
                        className='representation-form'
                        onChange={formValue => {
                            this.setState({ formValue });
                        }}
                        onSubmit={(value)=>this.handleSubmit(value)}
                    >
                        <div className='representation-title'>
                            <Icon icon='circle'/><span> فرم ذیل را کامل نمایید تا کارشناسان ما با شما تماس حاصل نمایند</span>
                        </div>
                        <br/>
                        <Row>
                            <Col xs={24} sm={12} smPush={12} mdPush={12} lgPush={12}>
                                <FormGroup>
                                    <ControlLabel className='representation-form-label'>نام و نام
                                        خانوادگی</ControlLabel>
                                    <FormControl id='input2' className='representation-form-input' placeholder='اجباری'
                                                 name='full_name'/>
                                </FormGroup>
                            </Col>
                            <Col sm={12} xs={24}  smPull={12} mdPull={12} lgPull={12}>
                                <FormGroup>
                                    <ControlLabel className='representation-form-label'>تلفن همراه</ControlLabel>
                                    <FormControl id='input1' className='representation-form-input' placeholder='اجباری'
                                                 name='phone'/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={12} smPush={12} mdPush={12} lgPush={12}>
                                <FormGroup>
                                    <ControlLabel className='representation-form-label'>استان</ControlLabel>
                                    <FormControl id='input3' data={this.state.state} onChange={(value) => getShahr(value)}
                                                 componentClass='select' className='representation-form-input'
                                                 placeholder='استان خود رو انتخاب کنید' name='state'>
                                        {
                                            ostan.map(item => (
                                                <option key={item.id}>{item.name}</option>
                                            ))
                                        }
                                    </FormControl>
                                </FormGroup>
                            </Col>
                            <Col xs={24} sm={12} smPull={12} mdPull={12} lgPull={12}>
                                <FormGroup>
                                    <ControlLabel className='representation-form-label'>شهر</ControlLabel>
                                    <FormControl id='shahrr' componentClass='select'
                                                 className='representation-form-input'
                                                 placeholder='شهر سکونت خود را انتخاب کنید'
                                                 name='region'
                                    >
                                        {
                                            getCities.map(item =>
                                                <option key={item.id}>{item.name}</option>
                                            )
                                        }
                                    </FormControl>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <FormGroup>
                                <Col sm={12} xs={12}>
                                    <FormControl id='latitude' className='representation-form-input' name='Latitude'
                                                 placeholder='عرض جغرافیایی' value={getLatLng[0]}
                                    />
                                </Col>
                                <Col sm={10} xs={12}>
                                    <FormControl  ld='longitude' className='representation-form-input' name='Longitude'
                                                 placeholder='طول جغرافیایی' value={getLatLng[1]}
                                    />
                                </Col>
                                <Col sm={2} xs={24}>
                                    <Button onClick={() => ToggleMapModal()} style={{width: '100%'}}><img
                                        className='orange-pin' src={pinOrange} alt='pin marker'/></Button>
                                </Col>
                            </FormGroup>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <FormGroup>
                                    <ControlLabel className='representation-form-label'>پست الکترونیک</ControlLabel>
                                    <FormControl id='input4' className='representation-form-input' name='email'
                                                 placeholder='اختیاری'/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <FormGroup>
                                    <ControlLabel className='representation-form-label'>پیام شما</ControlLabel>
                                    <FormControl id='input5' className='representation-form-input' name='msg'
                                                 componentClass='textarea' row={2} placeholder='اختیاری'/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Button type='submit' className='representation-submit-btn'>ارسال</Button>
                    </Form>
                </div>
                {mapModal ? <MapModalComponent /> : null}
            </div>
        );
    }
};
const mapStateToProps = createStructuredSelector({
    getCities: selectCities,
    mapModal: selectRepresentationModal,
    getLatLng: selectLatlng
});
const mapDispatchToProps = dispatch => ({
    setCities: cities => dispatch(SetCities(cities)),
    ToggleMapModal: () => dispatch({type: ModalTypes.TOGGLE_REPRESENTATION_MODAL}),
    setLatLng: latLng => dispatch(SetLatLng(latLng))
});

export default connect(mapStateToProps, mapDispatchToProps)(RepresentationLayout);